var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"h-brand-button",attrs:{"x-small":"","icon":"","ripple":false}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("$"+_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }